var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      minWidth: 14
    },
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15097 8.21132C7.60716 8.21132 7.99626 8.05031 8.31827 7.7283C8.64028 7.40629 8.80129 7.01719 8.80129 6.56101C8.80129 6.10482 8.64028 5.71572 8.31827 5.39371C7.99626 5.0717 7.60716 4.91069 7.15097 4.91069C6.69479 4.91069 6.30569 5.0717 5.98368 5.39371C5.66166 5.71572 5.50066 6.10482 5.50066 6.56101C5.50066 7.01719 5.66166 7.40629 5.98368 7.7283C6.30569 8.05031 6.69479 8.21132 7.15097 8.21132ZM7.15097 16C7.03022 16 6.90624 15.9767 6.77905 15.93C6.65132 15.8827 6.53378 15.8189 6.42644 15.7384C4.46753 13.9941 3.00506 12.3774 2.03902 10.8881C1.07298 9.39874 0.589966 8.01006 0.589966 6.72201C0.589966 4.66918 1.25063 3.03551 2.57195 1.82098C3.89381 0.606994 5.42015 0 7.15097 0C8.88179 0 10.4081 0.606994 11.73 1.82098C13.0513 3.03551 13.712 4.66918 13.712 6.72201C13.712 8.01006 13.229 9.39874 12.2629 10.8881C11.2969 12.3774 9.83441 13.9941 7.8755 15.7384C7.76816 15.8189 7.6509 15.8827 7.5237 15.93C7.39597 15.9767 7.27173 16 7.15097 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.4ec068b6c67ffc7f439e2c199218d3ba.svg";
export { ForwardRef as ReactComponent };